import React from 'react'
import FieldProto from "../../../../../../../fields3/proto/field-proto"
import GroupBy from "../../../../../../../gd/manager/group-by/group-by-model"
import PopupMenuButton from "../../../../../../../gd-components/popover-menu/popup-menu-button/popup-menu-button"
import DateGrouping_getGroupLabel from "../../../../../../../fields3/system/task/date/functions/get-group-label"
import FieldItemWithOptions_Popover from "./popover-options"

type Props = {
    field       : FieldProto
    params      : any

    selected    : boolean
    hasIcons    : boolean
    disabled?   : boolean

    onClick     : {(fieldId: ID, params: any, field?: FieldProto): void}
}

// const debug = "FieldItemWithOptions"
const debug = false

export default function FieldItemWithOptions(props:Props) {

    if (!props.field?.modifierOptionParamName) {
        console.error('FieldItemWithOptions render error: field modifierOptionParamName is not defined', props)
        return null
    }

    debug && console.log(debug, 'render', props)

    const groupBy = new GroupBy({
        fieldId : props.field?.fieldId,
        params  : props.params
    })

    const onClick = (option: Option) => {
        debug && console.log(debug, 'onClick', option)

        const params = {
            [props.field?.modifierOptionParamName!]: option.value
        }

        props.onClick(props.field?.fieldId, params, props.field)
    }

    const getButtonComponent = () => {
        const iconClasses = Classes("ico", props.field?.icon)

        let label
        if (props.selected) {
            label = DateGrouping_getGroupLabel(groupBy)
        } else {
            label = props.field?.label
        }

        return (
            <div className={Classes("option", {disabled: props.disabled})}>
                {props.hasIcons && <div className={iconClasses}/>}
                <div className="label w-100-percent">{label}</div>

                {props.selected && <div className="ui5-ico-13 i5-done action flex-no-shrink"/>}

                {/*<div className="ui5-ico-12 i5-angle-right flex-no-shrink m-l-5"/>*/}
                <div className="ui5-ico-9 i5-big-angle-right flex-no-shrink m-l-5"/>
            </div>
        )
    }

    return (
        <PopupMenuButton
            attachment          = "bottom left"
            targetAttachment    = "bottom right"
            attachmentType      = "vertical"
            offset              = "0 0"
            btnComponent        = {getButtonComponent}
            menuComponent       = {FieldItemWithOptions_Popover}
            menuParams          = {{
                groupBy : props.selected ? groupBy : undefined,
                field   : props.field,
                onClick : onClick
            }}
        />
    )
}